import { ThunkAction } from "redux-thunk";
import { RootState } from "../store";
import { AnyAction } from "redux";
import PortalPaymentsService from "../services/portalPayment";
import {
  setErrorMessage,
  setSuccessMessage,
} from "./actionsCreators/messageActions";
import { DELETE_USER_SUCCESS } from "../lib/constants";

export const deletePaymentMethod =
  (req: any): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const res = await PortalPaymentsService.remove(req);

      dispatch(setSuccessMessage(DELETE_USER_SUCCESS));

      return await Promise.resolve(res);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));

      return await Promise.reject(error);
    }
  };
